import { render, staticRenderFns } from "./BtnExcluirResponsavel.vue?vue&type=template&id=8a7fa478"
import script from "./BtnExcluirResponsavel.vue?vue&type=script&lang=js"
export * from "./BtnExcluirResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports